import RoleRewards from "@ugg/shared/components/Champions/pages/Overview/RoleRewards";
import RoleQuestRequirements from "@ugg/shared/components/Champions/pages/Overview/RoleQuestRequirements";
import { QueueTypeS } from "@ugg/shared/utils/queue-type-helpers";
import { tierListSettings } from "@ugg/shared/components/TierList/lib/tier-list-settings";
interface CommonProps extends RoleQuestProps {
  className?: string;
}
interface RoleQuestProps {
  champID: number;
  questCompletionTime?: [number];
  role: string;
  queueType: QueueTypeS;
}

export default function RoleQuest(props: RoleQuestProps) {
  const { role, champID, questCompletionTime, queueType } = props;

  if (!tierListSettings[queueType]?.showRoleQuest) {
    return null;
  } else {
    return (
      <div className={`grid grid-cols-1 gap-[12px] mt-3 md:grid-cols-2 md:gap-[1px]`}>
        <RoleQuestRequirements role={role}></RoleQuestRequirements>
        <RoleRewards champID={champID} questCompletionTime={questCompletionTime} role={role}></RoleRewards>
      </div>
    );
  }
}
